<template>
  <div id="register">
    <!--<div class="ibg-bg" style="transform: matrix(1, 0, 0, 1, 0, 0); transition: all 500ms linear 0s;"></div>-->
    <div class="register-header">
      <div class="logo" style="margin: 15px;">
        <img style="width: 225px;" :src="baseUrl+'gc-logo.png'">
      </div>
      <span class="logo" style="width: 100px;margin: 19px;">忘记密码</span>
    </div>
    <div class="ibg-bg">
      <div class="register-container" content="center" style="margin-top: 20px;">
        <div class="con-box" content="center">
          <div class="register-form" style="margin:0 10px;">
            <el-form status-icon ref="ruleForm" class="demo-ruleForm" size="medium" style="padding:30px;">
              <el-form-item>
                <el-input type="text" v-model="accountComputed" placeholder="手机号/邮箱"></el-input>
              </el-form-item>
              <el-form-item v-if="type==='phone'">
                <div style="display: flex; flex-direction: row">
                  <el-input type="text" v-model="code" placeholder="验证码" style="margin-right: 12px;"></el-input>
                  <el-button type="primary" @click="sendVeriCode" :loading="coolDown" :disabled="disabledSend">{{sendCodeText}}</el-button>
                </div>
              </el-form-item>
              <el-form-item prop="password" v-if="type==='phone'">
                <el-input type="password" v-model="password" placeholder="新密码"></el-input>
              </el-form-item>
              <el-form-item prop="rePassword" v-if="type==='phone'">
                <el-input type="password" v-model="rePassword" placeholder="确认密码"></el-input>
              </el-form-item>
              <el-form-item class="submit-btn" v-if="type==='phone'">
                <el-button type="primary" @click="submit" style="width: 100%;" :disabled="disableSubmit">提交</el-button>
                <el-button type="text" @click="returnLogin" style="float: left;">返回登录</el-button>
              </el-form-item>
              <el-form-item class="submit-btn" v-if="type==='email'">
                <el-button type="primary" @click="sendEmail" style="width: 100%;" :disabled="account===''">发送邮件</el-button>
                <el-button type="text" @click="returnLogin" style="float: left;">返回登录</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="register-foot foot">
        <foot></foot>
      </div>
    </div>
  </div>
</template>
<script>
import md5 from 'js-md5'
import ct from '../../utils/constant.js'
import { setStorage, sendVerCode } from '../../utils/utils.js'
import foot from '../../components/Footer.vue'
export default {
  created () {
  },
  mounted () {
  },
  components: {
    foot
  },
  data () {
    return {
      loading: false,
      password: '',
      rePassword: '',
      account: '',
      type: 'phone',
      code: '',
      disableSubmit: true,
      coolDown: false,
      sendVeriCodeSuccess: false,
      sendCodeText: '发送',
      baseUrl: 'static/img/'
    }
  },
  watch: {
    'code': function (val) {
      let reg = new RegExp(/^\d{6}$/)
      if (this.sendVeriCodeSuccess || reg.test(val)) {
        this.disableSubmit = false
      } else {
        this.disableSubmit = true
      }
    }
  },
  methods: {
    sendVeriCode () {
      let phone = this.account.replace(/\s+/g, '')
      if (!this.phoneVeri(phone)) {
        this.$message({message: '请输入11位正确格式的手机号码！', type: 'error'})
        return
      }
      sendVerCode(this, ct.SendVeriCodeType.resetPass)
    },
    login () {
      if (this.account && this.password) {
        this.postRequest('gcwwwifc/login', {
          'LoginId': this.account.replace(/\s+/g, ''),
          'Password': md5(this.password).toUpperCase()
        }).then((response) => {
          this.$router.push(ct.RouterData.netDisk.path)
          setStorage('user', response.data.result)
        })
      } else {
        // $.toast('请输入登录信息')
      }
    },
    returnLogin () {
      this.$router.push(ct.RouterData.login.path)
    },
    submit () {
      let phone = this.account.replace(/\s+/g, '')
      if (!this.phoneVeri(phone)) {
        this.$message({message: '请输入11位正确格式的手机号码！', type: 'error'})
        return
      }
      if (this.password !== this.rePassword) {
        this.$message({message: '两次输入的密码不一致', type: 'error'})
        return
      }
      this.postRequest('gcwwwifc/submitResetPassword', {'LoginId': this.account, 'NewPassword': md5(this.password).toUpperCase(), 'VerifyCode': this.code})
        .then((res) => {
          if (res) {
            if (res.data.code === 0) {
              this.$message({message: '修改成功', type: 'success'})
              this.login()
            } else {
              this.$message({message: res.data.message, type: 'error'})
            }
          }
        })
    },
    sendEmail () {
      this.postRequest('gcwwwifc/requestResetPassword', {'LoginId': this.account})
        .then((res) => {
          if (res.data.code === 0) {
            this.$message({message: res.data.message, type: 'success'})
            this.$router.push(ct.RouterData.login.path)
          } else {
            this.$message({message: res.data.message, type: 'error'})
          }
        })
    }
  },
  computed: {
    disabledSend () {
      return !this.account || this.account === ''
    },
    accountComputed: {
      get () {
        return this.account
      },
      set (val) {
        this.account = val
        if (val.indexOf('@') !== -1) {
          this.type = 'email'
        } else {
          this.type = 'phone'
        }
      }
    }
  }
}
</script>
<style scoped>
 </style>



// WEBPACK FOOTER //
// src/pages/login/ForgetPassword.vue